import { defineNuxtPlugin, useRuntimeConfig } from "#imports";
import vVoixBackgroundColor from "@voix/directives/v-voix-background-color";
import vVoixPopper from "@voix/directives/v-voix-popper";
import vVoixText from "@voix/directives/v-voix-text";
import vVoixTextColor from "@voix/directives/v-voix-text-color";
import vVoixVisibility from "@voix/directives/v-voix-visibility";
import { useLayoutStore } from "@voix/store/layoutStore";
import { useSliceStore } from "@voix/store/sliceStore";
import layoutsConfig from "virtual:voix-layouts-config";
import slicesConfig from "virtual:voix-slices-config";
import { ref } from "vue";
import authMiddlewareSetup from "./voix-plugin-utils/auth-middleware-setup.js";
import voixApplicationSetup from "./voix-plugin-utils/voix-application-setup.js";
import voixBreakpointsSetup from "./voix-plugin-utils/voix-breakpoints-setup.js";
import voixEventsSetup from "./voix-plugin-utils/voix-events-setup.js";
import voixFetchSetup from "./voix-plugin-utils/voix-fetch-setup.js";
import voixLocaleSetup from "./voix-plugin-utils/voix-locale-setup.js";
export default defineNuxtPlugin({
  name: "voix",
  enforce: "post",
  // Ensure this runs after other plugins, including Pinia
  async setup(NuxtApp) {
    const voixConfig = useRuntimeConfig().public.voix.options;
    const voixOptions = Object.assign({}, voixConfig);
    if (!voixOptions.languages?.length) {
      voixOptions.languages = [
        {
          code: "en",
          name: "English",
          icon: "\u{1F1FA}\u{1F1F8}",
          file: "en.json"
        }
      ];
    }
    let voix = {
      options: voixOptions,
      breakpoint: ref("")
    };
    const sliceStore = useSliceStore();
    sliceStore.slices = slicesConfig;
    const layoutStore = useLayoutStore();
    layoutStore.layouts = layoutsConfig;
    NuxtApp.vueApp.directive("voix-text", vVoixText);
    NuxtApp.vueApp.directive("voix-text-color", vVoixTextColor);
    NuxtApp.vueApp.directive("voix-background-color", vVoixBackgroundColor);
    NuxtApp.vueApp.directive("voix-visibility", vVoixVisibility);
    NuxtApp.vueApp.directive("voix-popper", vVoixPopper);
    voix = voixBreakpointsSetup(voix);
    voix = voixFetchSetup(voix);
    voix = voixEventsSetup(voix);
    const { t, getCurrentLocale } = voixLocaleSetup();
    voix.getCurrentLocale = getCurrentLocale;
    authMiddlewareSetup();
    voixApplicationSetup();
    return {
      provide: {
        voix,
        t
      }
    };
  }
});
